import { render, staticRenderFns } from "./RulesPopups.vue?vue&type=template&id=5f2d140c&scoped=true&"
import script from "./RulesPopups.vue?vue&type=script&lang=js&"
export * from "./RulesPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d140c",
  null
  
)

export default component.exports